import React from 'react';
import { AccordionContextItemProps, AccordionContextProps } from './types';

export const AccordionContext = React.createContext<AccordionContextProps>(undefined);
AccordionContext.displayName = 'AccordionContext';

export const AccordionItemContext = React.createContext<AccordionContextItemProps>(undefined);
AccordionItemContext.displayName = 'AccordionItemContext';
